import "./bootstrap";
import "./alpine-scripts";
import "./sliders";
